import React, { useState, useRef, useEffect, useMemo } from "react";
import Icon from "components/Icon";
import TestBro from "assets/images/testBro.png";
import Eye from "assets/images/eye.svg";
import Play from "assets/images/play.svg";
import avatar2 from "assets/images/test-avatar.png";
import avatar3 from "assets/images/testgirl.png";
import switchArrow from "assets/images/switch.svg";
import Box from "ui-box";
import { VideoModal } from "./videoModal";
import { useScroll, motion, useTransform } from "framer-motion";
import member1 from "assets/images/member1.png";
import member2 from "assets/images/member2.png";
import member3 from "assets/images/member3.png";
import member4 from "assets/images/member4.png";
import stripe from "assets/images/purpleStripes.svg";
import member1Circle from "assets/images/member1Circle.png";
import member2Circle from "assets/images/member2Circle.png";
import member3Circle from "assets/images/member3Circle.png";
import member4Circle from "assets/images/member4Circle.png";
import { gaTestimonialSlide, gaViewTestimonial } from "utils/analytics";

const Testimonials = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [flippedStates, setFlippedStates] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevBtnClass, setPrevBtnClass] = useState("testimonial-prev");
  const [nextBtnClass, setNextBtnClass] = useState("testimonial-next");
  const topTextRef = useRef(null);
  const { scrollYProgress: topText } = useScroll({
    target: topTextRef,
    offset: ["0 1", "1.33 1"]
  });

  const topTextScaleProgress = useTransform(topText, [0, 1], [0.8, 1]);
  const topTextOpacityProgress = useTransform(topText, [0, 1], [0.2, 1]);
  // memorize the handleFlip function
  const handleFlip = useMemo(
    () => (cardIndex) => {
      if (!isAnimating) {
        setIsAnimating(true);
        setFlippedStates((prevStates) => ({
          ...prevStates,
          [cardIndex]: !prevStates[cardIndex]
        }));
        gaViewTestimonial("View testimonial by flipping");
      }
    },
    []
  );

  const onAnimationComplete = () => {
    setIsAnimating(false);
  };

  //memorize the handleLeftClick and handleRightClick functions
  const handleLeftClick = useMemo(
    () => () => {
      if (currentIndex > 0) {
        setCurrentIndex((prevIndex) => prevIndex - 1);
        setFlippedStates({});
        gaTestimonialSlide("Slided testimonial");
      }
    },
    [currentIndex]
  );

  const handleRightClick = useMemo(
    () => () => {
      if (currentIndex < 3) {
        setCurrentIndex((prevIndex) => prevIndex + 1);
        setFlippedStates({});
        gaTestimonialSlide("Slided testimonial");
      }
    },
    [currentIndex]
  );

  const computeCardStyle = (cardIndex) => {
    let style = {};
    switch (cardIndex) {
      case 1:
        if (currentIndex >= 1) {
          style = { transform: `scale3d(0.3, 0.3, 0.3)`, opacity: 0 };
        }
        break;
      case 2:
        if (currentIndex >= 1) {
          style = { transform: `translateX(-100%)` };
        }
        if (currentIndex > 1) {
          style = {
            transform: `translateX(-100%) scale3d(0.3, 0.3, 0.3)`,
            opacity: 0
          };
        }
        break;
      case 3:
        if (currentIndex === 1) {
          style = { transform: `translateX(-100%)` };
        } else if (currentIndex === 2) {
          style = { transform: `translateX(-200%)` };
        } else if (currentIndex === 3) {
          style = { transform: `translateX(-200%) scale3d(0.3, 0.3, 0.3)` };
        }
        break;
      case 4:
        if (currentIndex === 1) {
          style = { transform: `translateX(-100%)` };
        } else if (currentIndex === 2) {
          style = { transform: `translateX(-200%)` };
        } else if (currentIndex === 3) {
          style = { transform: `translateX(-300%)` };
        }
        break;
      default:
        break;
    }
    return style;
  };

  const updateButtonStyles = (index) => {
    const isBeginning = index === 0;
    const isEnd = index === 3;

    setPrevBtnClass(
      isBeginning ? "testimonial-prev-disabled" : "testimonial-prev"
    );
    setNextBtnClass(isEnd ? "testimonial-next-disabled" : "testimonial-next");
  };

  useEffect(() => {
    updateButtonStyles(currentIndex);
  }, [currentIndex]);

  return (
    <div className="testimonial-overall-container">
      <div className="testimonial-container">
        <div className="testimonial-container-grid">
          <div className="testimonial-top-text">
            <motion.div
              ref={topTextRef}
              style={{
                scale: topTextScaleProgress,
                opacity: topTextOpacityProgress
              }}
            >
              {" "}
              <h1 className="testimonial-righttext">
                For people <br /> going places
              </h1>
            </motion.div>
          </div>

          <div className="testimonial-buttons">
            <button
              className={prevBtnClass}
              onClick={handleLeftClick}
              disabled={currentIndex === 0}
              aria-label="Previous testimonial"
            >
              {" "}
              <Icon
                id="left-arrow"
                fill={
                  prevBtnClass === "testimonial-prev-disabled"
                    ? "#4824C1"
                    : "white"
                }
              />
            </button>

            <button
              className={nextBtnClass}
              disabled={currentIndex === 3}
              aria-label="Next testimonial"
              onClick={handleRightClick}
            >
              {" "}
              <Icon
                style={{ transform: "rotate(180deg)" }}
                id="left-arrow"
                fill={
                  nextBtnClass === "testimonial-next-disabled"
                    ? "#4824C1"
                    : "white"
                }
              />
            </button>
          </div>

          <div className="testimonial-card-container">
            <div className="testimonial-card-container-inner">
              {/* First card */}
              {/* Text card start */}
              <div
                className="testimonial-text-card transition"
                style={computeCardStyle(1)}
              >
                <motion.div
                  className="flip-card-inner"
                  initial={false}
                  animate={{
                    rotateY: flippedStates.card1 ? 180 : 360
                  }}
                  transition={{ duration: 0.2, animationDirection: "normal" }}
                  onAnimationComplete={onAnimationComplete}
                >
                  <div className="testimonial-text-card__front">
                    <img
                      src={member1}
                      className="testimonial-text-card__front-image"
                    />
                    {!flippedStates.card1 && (
                      <motion.div
                        //  animate opacity to 1 in 0.5 seconds
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1 }}
                        className="testimonial-text-card__front-innercard"
                      >
                        <p>
                          "Iddera is the support system for achieving my
                          lifestyle goals. I love the focused attention and
                          personal touch."
                        </p>
                        <p className="testimonial-name ">Babajide Olusesi</p>
                        <button onClick={() => handleFlip("card1")}>
                          <img src={Eye} />
                          See More
                        </button>
                      </motion.div>
                    )}
                  </div>
                  <div className="testimonial-text-card__back">
                    <Box
                      display="flex"
                      width="100%"
                      justifyContent="flex-end"
                      marginBottom="1rem"
                      cursor="pointer"
                      onClick={() => handleFlip("card1")}
                    >
                      <img src={switchArrow} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <img
                        src={member1Circle}
                        className="testimonial-text-card__back-avatar"
                      />
                      <h1 className="testimonial-text-card__back-name">
                        Babajide Olusesi
                      </h1>

                      <p className="testimonial-text-card__back-info">
                        "I honestly think the service would be beneficial to
                        people seeking improvement or results. I’m happy with
                        the level of support and attention I get consistently."
                      </p>
                    </Box>
                  </div>
                </motion.div>
              </div>
              {/* Text card end */}
              {/* Second card */}
              {/* Video card */}
              {/* <div
                className="testimonial-text-card transition"
                style={computeCardStyle(2)}
              >
                <div className="testimonial-video-card__front">
                  <img
                    src={member2}
                    className="testimonial-video-card__front-image"
                  />
                  <div className="testimonial-video-card__front-innercard">
                    <p>
                      "Iddera has completely changed my relationship with my
                      health. I am definitely a lot more productive."
                    </p>
                    <button onClick={() => setShowModal(true)}>
                      <img src={Play} />
                      Watch video
                    </button>
                  </div>
                </div>
              </div> */}

              <div
                className="testimonial-text-card transition"
                style={computeCardStyle(2)}
              >
                <motion.div
                  className="flip-card-inner"
                  initial={false}
                  animate={{ rotateY: flippedStates.card3 ? 180 : 360 }}
                  transition={{ duration: 0.2, animationDirection: "normal" }}
                  onAnimationComplete={onAnimationComplete}
                >
                  <div className="testimonial-text-card__front">
                    <img
                      src={member3}
                      className="testimonial-text-card__front-image"
                    />
                    {!flippedStates.card3 && (
                      <div className="testimonial-text-card__front-innercard">
                        <p>
                          "Iddera makes it easier and more enjoyable to make the
                          right/healthy lifestyle choices."
                        </p>
                        <p className="testimonial-name ">Stephanie Mofunanya</p>
                        <button onClick={() => handleFlip("card3")}>
                          <img src={Eye} />
                          See More
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="testimonial-text-card__back">
                    <Box
                      display="flex"
                      width="100%"
                      justifyContent="flex-end"
                      marginBottom="1rem"
                      cursor="pointer"
                      onClick={() => handleFlip("card3")}
                    >
                      <img src={switchArrow} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <img
                        src={member3Circle}
                        className="testimonial-text-card__back-avatar"
                      />
                      <h1 className="testimonial-text-card__back-name">
                        Stephanie Mofunanya
                      </h1>

                      <p className="testimonial-text-card__back-info">
                        "It’s like having a personal health coach that manages
                        my overall wellbeing. I am more consistent with my
                        wellness goals and I am more energised."
                      </p>
                    </Box>
                  </div>
                </motion.div>
              </div>

              {/* Video card end */}

              {/* Text card start */}

              <div
                className="testimonial-text-card transition"
                style={computeCardStyle(3)}
              >
                <motion.div
                  className="flip-card-inner"
                  initial={false}
                  animate={{ rotateY: flippedStates.card2 ? 180 : 360 }}
                  transition={{ duration: 0.2, animationDirection: "normal" }}
                  onAnimationComplete={onAnimationComplete}
                >
                  <div className="testimonial-text-card__front">
                    <img
                      src={member2}
                      className="testimonial-text-card__front-image"
                    />
                    {!flippedStates.card2 && (
                      <div className="testimonial-text-card__front-innercard">
                        <p>
                          "Iddera feels really personal. My doctor, nutritionist
                          and fitness coach are invested in my overall
                          wellbeing."
                        </p>
                        <p className="testimonial-name ">David Olamide</p>
                        <button onClick={() => handleFlip("card2")}>
                          <img src={Eye} />
                          See More
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="testimonial-text-card__back">
                    <Box
                      display="flex"
                      width="100%"
                      justifyContent="flex-end"
                      marginBottom="1rem"
                      cursor="pointer"
                      onClick={() => handleFlip("card2")}
                    >
                      <img src={switchArrow} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <img
                        src={member2Circle}
                        className="testimonial-text-card__back-avatar"
                      />
                      <h1 className="testimonial-text-card__back-name">
                        David Olamide
                      </h1>

                      <p className="testimonial-text-card__back-info">
                        "The human interaction and the response rate on the app
                        when I need urgent attention from my doctor has always
                        been great."
                      </p>
                    </Box>
                  </div>
                </motion.div>
              </div>

              {/* Text card end */}

              {/* Fourth card */}
              {/* Video card */}
              <div
                className="testimonial-text-card transition"
                style={computeCardStyle(4)}
              >
                <motion.div
                  className="flip-card-inner"
                  initial={false}
                  animate={{ rotateY: flippedStates.card4 ? 180 : 360 }}
                  transition={{ duration: 0.2, animationDirection: "normal" }}
                  onAnimationComplete={onAnimationComplete}
                >
                  <div className="testimonial-text-card__front">
                    <img
                      src={member4}
                      className="testimonial-text-card__front-image"
                    />
                    {!flippedStates.card4 && (
                      <div className="testimonial-text-card__front-innercard">
                        <p>
                          "I nook’d with my doctors and I got hooked to telling
                          them about everything. Absolutely my best healthcare
                          experience."
                        </p>
                        <p className="testimonial-name ">Ijeoma Okuneye</p>
                        <button onClick={() => handleFlip("card4")}>
                          <img src={Eye} />
                          See More
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="testimonial-text-card__back">
                    <Box
                      display="flex"
                      width="100%"
                      justifyContent="flex-end"
                      marginBottom="1rem"
                      cursor="pointer"
                      onClick={() => handleFlip("card4")}
                    >
                      <img src={switchArrow} />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <img
                        src={member4Circle}
                        className="testimonial-text-card__back-avatar"
                      />
                      <h1 className="testimonial-text-card__back-name">
                        Ijeoma Okuneye
                      </h1>

                      <p className="testimonial-text-card__back-info">
                        “Iddera has exceptional doctors and the timeliness of
                        their response is awesome. They are very attentive,
                        calm, professsional, and knowledgeable. Iddera is my
                        go-to place for everything and anything wellness.”
                      </p>
                    </Box>
                  </div>
                </motion.div>
              </div>
              {/* Video card end */}
            </div>
          </div>
        </div>
        <img src={stripe} className="testimonial-stripe" />
        <VideoModal isOpen={showModal} closeModal={() => setShowModal(false)} />
      </div>
    </div>
  );
};

export default Testimonials;
